import { COMPANY_DETAILS, BUSINESS_NAME } from '@/src/constants';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": BUSINESS_NAME,
  "url": "https://agrandintl.com",
  "logo": "https://agrandintl.com/logo.png",
  "description": COMPANY_DETAILS.description,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Washington DC",
    "addressRegion": "DC",
    "addressCountry": "US"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": COMPANY_DETAILS.phone,
    "contactType": "customer service",
    "email": COMPANY_DETAILS.email,
    "areaServed": ["DC", "VA", "MD"],
    "availableLanguage": "English"
  },
  "founder": {
    "@type": "Person",
    "name": COMPANY_DETAILS.founderName
  }
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": BUSINESS_NAME,
  "image": "https://agrandintl.com/og-image.jpg",
  "@id": "https://agrandintl.com",
  "url": "https://agrandintl.com",
  "telephone": COMPANY_DETAILS.phone,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Washington DC",
    "addressRegion": "DC",
    "postalCode": "20001",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 38.9072,
    "longitude": -77.0369
  },
  "areaServed": [
    {
      "@type": "AdministrativeArea",
      "name": "Washington DC"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Virginia"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Maryland"
    }
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  }
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": BUSINESS_NAME,
  "url": "https://agrandintl.com",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://agrandintl.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Cybersecurity Consulting",
  "provider": {
    "@type": "Organization",
    "name": BUSINESS_NAME
  },
  "areaServed": ["DC", "VA", "MD"],
  "description": "Professional cybersecurity risk audits, vulnerability assessments, and compliance consulting for retail and cloud-based businesses."
};
